import React, { useState } from "react";
import LabeledToggle from "components/Inputs/Toggle/Toggle";
import { updateGuardrailsSystemInstruction, updateGuardrailsOutputInstruction, updateGuardrailsInputInstruction, getDefaultGuardrailsInputInstruction, getDefaultGuardrailsOutputInstruction, updateGuardrailsGenerationConfigModel, getGuardrailsInputInstruction, getGuardrailSystemInstruction, getGuardrailsOutputInstruction, getGuardrailsGenerationConfig, updateGuardrails, getDefaultGuardrailsSystemInstruction } from "containers/ChatGPT/reducer";
import { useSelector, useDispatch } from "types/store";
import { Accordion, Button } from "aible";
import styles from "../style.module.css";
import IconVideoOptionsGray from "images/video_options_gray.svg";
import ModelSelector from "../ModelSelector";
const GuardrailsSettings = ({ disableButtons }) => {
    const dispatch = useDispatch();
    const defaultInputInstruction = useSelector(getDefaultGuardrailsInputInstruction);
    const defaultOutputInstruction = useSelector(getDefaultGuardrailsOutputInstruction);
    const defaultSystemInstruction = useSelector(getDefaultGuardrailsSystemInstruction);
    const input_instructions = useSelector(getGuardrailsInputInstruction);
    const output_instructions = useSelector(getGuardrailsOutputInstruction);
    const system_instructions = useSelector(getGuardrailSystemInstruction);
    const generation_config = useSelector(getGuardrailsGenerationConfig);
    const [showOptions, setShowOptions] = useState(false);
    const use_input_rail = input_instructions !== undefined && input_instructions !== "";
    const use_output_rail = output_instructions !== undefined && output_instructions !== "";
    const settingLabelText = () => {
        const baseText = "Enable NVIDIA NeMo Guardrails to guard against malicious questions or answers";
        const enabledText = "NVIDIA Nemo Guardrails is enabled to guard against: ";
        if (use_input_rail || use_output_rail) {
            return enabledText;
        }
        else {
            return baseText;
        }
    };
    const settingEnabledText = () => {
        if (use_input_rail) {
            if (use_output_rail) {
                return "questions and answers";
            }
            return "questions";
        }
        else if (use_output_rail) {
            return "answers";
        }
        return undefined;
    };
    return (React.createElement("div", { style: { marginTop: "20px" } },
        React.createElement("div", { style: { display: "flex", justifyContent: "space-between" } },
            React.createElement("div", { style: { display: "flex", alignItems: "center" } },
                React.createElement(LabeledToggle, { style: { display: "block" }, checked: use_input_rail || use_output_rail, onClick: () => {
                        if (use_input_rail || use_output_rail) {
                            dispatch(updateGuardrails(undefined));
                            setShowOptions(false);
                        }
                        else {
                            dispatch(updateGuardrails({
                                input_instructions: defaultInputInstruction,
                                output_instructions: defaultOutputInstruction,
                                system_instructions: defaultSystemInstruction
                            }));
                        }
                    }, disabled: disableButtons, isAibleColors: true }),
                React.createElement("div", { style: { marginLeft: "14px" } },
                    settingLabelText(),
                    settingEnabledText() && React.createElement("span", { className: "font-bold" }, settingEnabledText()))),
            React.createElement(Button, { isSmall: true, type: "secondary", active: showOptions, style: { marginRight: "6px" }, onClick: () => setShowOptions(!showOptions) },
                React.createElement("img", { src: IconVideoOptionsGray, style: { width: "18px" } }))),
        showOptions && (React.createElement("div", { style: { marginTop: "20px" } },
            React.createElement("div", { style: {
                    display: "flex",
                    alignItems: "center",
                    marginTop: "20px"
                } },
                React.createElement("span", { style: { color: "#202939" } }, "Selected Guardrails Model"),
                React.createElement(ModelSelector, { modelId: generation_config?.model, updateModelId: (modelId) => {
                        dispatch(updateGuardrailsGenerationConfigModel(modelId));
                    }, hideIcons: true, isCreatable: true, selectorStyle: {
                        marginLeft: "15px"
                    }, style: { flexShrink: "1", whiteSpace: "normal" } })),
            React.createElement("div", { style: { marginTop: "20px" } },
                React.createElement("span", { style: { marginBottom: "5px" } },
                    React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", checked: use_input_rail, onClick: () => {
                            if (!use_input_rail) {
                                dispatch(updateGuardrailsInputInstruction(defaultInputInstruction));
                            }
                            else {
                                dispatch(updateGuardrailsInputInstruction(""));
                            }
                        } }),
                    React.createElement("span", { style: { fontWeight: 700, marginRight: "5px" } }, "User Question Guardrails:"),
                    "What content would you like Aible to detect and not answer in user questions"),
                React.createElement("textarea", { className: styles.settingPrompt, value: input_instructions, onChange: (val) => dispatch(updateGuardrailsInputInstruction(val.target.value)), disabled: disableButtons, placeholder: "Prevent malicious, hateful, violent, or unsafe content." })),
            React.createElement("div", { style: { marginTop: "20px" } },
                React.createElement("span", { style: { marginBottom: "5px" } },
                    React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", checked: use_output_rail, onClick: () => {
                            if (!use_output_rail) {
                                dispatch(updateGuardrailsOutputInstruction(defaultOutputInstruction));
                            }
                            else {
                                dispatch(updateGuardrailsOutputInstruction(""));
                            }
                        } }),
                    React.createElement("span", { style: { fontWeight: 700, marginRight: "5px" } }, "AI Response Guardrails:"),
                    "What content would you like Aible to detect and not answer in the AI answers"),
                React.createElement("textarea", { className: styles.settingPrompt, value: output_instructions, onChange: (val) => dispatch(updateGuardrailsOutputInstruction(val.target.value)), disabled: disableButtons, placeholder: "Prevent malicious, hateful, violent, or unsafe content." })),
            React.createElement("div", { style: { marginTop: "20px" } },
                React.createElement(Accordion, { header: React.createElement("div", { className: styles.chatSettingsItemHeader }, "Advanced Options") },
                    React.createElement("span", { style: { marginBottom: "5px" } },
                        React.createElement("span", { style: { fontWeight: 700, marginRight: "5px" } }, "System Message:"),
                        "Clarify how the agent should interpret guardrail instructions."),
                    React.createElement("textarea", { className: styles.settingPrompt, value: system_instructions, onChange: (val) => dispatch(updateGuardrailsSystemInstruction(val.target.value)), disabled: disableButtons, placeholder: "Prevent malicious, hateful, violent, or unsafe content." })))))));
};
export default GuardrailsSettings;
